import { render, staticRenderFns } from "./ShowDialogEspecialidad.vue?vue&type=template&id=d826fb68&scoped=true"
import script from "./ShowDialogEspecialidad.vue?vue&type=script&lang=js"
export * from "./ShowDialogEspecialidad.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogEspecialidad.vue?vue&type=style&index=0&id=d826fb68&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d826fb68",
  null
  
)

export default component.exports